
<v-menu offset-y content-class="white" max-height="calc(100% - 104px)" v-model="showSites" nudge-top="-4">
    <template v-slot:activator="{ on, attrs }">
        <div
            v-bind = "attrs"
            v-on   = "on"
            class  = "v-flex"
        >
            <div
                v-for  = "(site, idx) in maxsites"
                :key   = "site.id"
                class  = "site-box"
                :class = "color"
                :style = "boxsize"
            >
                <div v-if="idx === index" class="site-indicator"></div>
            </div>
            <div v-if="sites && sites.length > 5">
                <i class="fas fa-ellipsis-h " :class="index >= maxsites.length ? 'orange--text' : 'white--text'"></i>
            </div>
        </div>
    </template>

    <div class="pa-2 pr-1 pl-2" style="border-radius: 5px; overflow-y: scroll; position: relative">
        <a
            v-for  = "(unit, index) in sites"
            :key   = "unit.id"
            @click = "onSelect(unit)"
        >
            <v-hover
                v-slot="{ hover }"
            >
                <div>
                    <slot name="header" v-bind:data="{ unit: unit, compact: false }" />
                    <c-site-card-dense
                        :site  = "unit"
                        style  = "width: 300px;"
                        :class = "index < sites.length-1 ? 'mb-2 ' + background(unit) : background(unit)"
                        :style = "hover ? 'background-color: #f0f0f0' : ''"
                    />
                </div>
            </v-hover>
        </a>
    </div>
</v-menu>
